import { SET_SUBMISSION } from '../actions/types';

const initialState = {
  status: 'idle',
  errors: null,
  message: null,
  listing: null,
};

export default function submission(state = initialState, action = {}) {
  switch (action.type) {
    case SET_SUBMISSION:
      return { ...initialState, ...action.payload };

    default:
      return state;
  }
}
